import { usePluginMessages } from '../../../composition/plugin-runtime';

export function HelloPage() {
  const t = usePluginMessages('hello');
  return <h1>{t('page')}</h1>;
}
